import React from 'react';

// Sin esto, cualquier error no capturado durante el render (en cualquier
// pantalla de cualquiera de las apps que comparten FrGlobal) deja la app
// entera en blanco en producción — react-scripts build no tiene el overlay
// rojo de errores que sí se ve en dev, así que el usuario solo ve pantalla
// vacía y no queda ningún rastro del error real en ningún lado.
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: null };
    }

    static getDerivedStateFromError(error) {
        return { error };
    }

    componentDidCatch(error, info) {
        console.error('ErrorBoundary capturó un error de render:', error, info.componentStack);
    }

    render() {
        if (this.state.error) {
            return (
                <div style={{
                    maxWidth: '560px', margin: '60px auto', padding: '24px 28px',
                    border: '1px solid #e0e0e0', borderRadius: '8px',
                    fontFamily: 'system-ui, sans-serif', textAlign: 'center',
                }}>
                    <h4 style={{ color: '#c0392b', marginBottom: '10px' }}>Ocurrió un error inesperado</h4>
                    <p style={{ color: '#555', fontSize: '14px', marginBottom: '18px' }}>
                        {this.state.error.message || String(this.state.error)}
                    </p>
                    <button
                        className="btn btn-primary"
                        onClick={() => window.location.reload()}
                    >
                        Recargar página
                    </button>
                </div>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
